<mat-sidenav-container class="qira-shell">
  <mat-sidenav #drawer class="qira-sidebar" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async)" [fixedInViewport]="(isHandset$ | async) ?? false"
    [disableClose]="!(isHandset$ | async)">
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="qira-shell__content">
    <mat-toolbar class="qira-topbar">
      <button mat-icon-button class="qira-topbar__burger" *ngIf="isHandset$ | async" (click)="drawer.toggle()"
        aria-label="Open menu">
        <mat-icon>menu</mat-icon>
      </button>

      <span class="qira-topbar__title">Security Deposit</span>

      <span class="spacer"></span>

      <app-shell-global-search class="qira-topbar__search hide-mobile"></app-shell-global-search>

      <button type="button" class="qira-theme-toggle" (click)="toggleTheme()"
        [attr.aria-label]="theme.isDark() ? 'Switch to light mode' : 'Switch to dark mode'">
        <mat-icon>{{ theme.isDark() ? 'light_mode' : 'bedtime' }}</mat-icon>
      </button>

      <button type="button" class="qira-bell" [matMenuTriggerFor]="notifMenu" aria-label="Notifications" *ngIf="false">
        <mat-icon>notifications_none</mat-icon>
        <span class="qira-bell__dot" *ngIf="hasUnreadNotifications"></span>
      </button>

      <mat-menu #notifMenu="matMenu" class="qira-notif-menu">
        <div class="qira-notif-menu__header" mat-menu-item disabled>
          <span class="qira-notif-menu__title">Notifications</span>
        </div>
        <mat-divider></mat-divider>
        <div class="qira-notif-menu__empty" mat-menu-item disabled>
          <mat-icon>notifications_off</mat-icon>
          <span>You're all caught up</span>
        </div>
      </mat-menu>

      <button type="button" [matMenuTriggerFor]="userMenu" class="qira-topbar__user" aria-label="Account menu"
        *ngIf="isAuthenticated">
        <span class="qira-topbar__avatar">{{ userInitials }}</span>
        <span class="qira-topbar__user-name hide-mobile">{{ user?.name }}</span>
        <mat-icon class="qira-topbar__user-chevron hide-mobile">expand_more</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu" class="qira-user-menu">
        <div class="qira-user-menu__profile" mat-menu-item disabled>
          <div class="qira-user-menu__avatar">{{ userInitials }}</div>
          <div class="qira-user-menu__identity">
            <span class="qira-user-menu__name">{{ user?.name }}</span>
            <span class="qira-user-menu__email">{{ user?.email }}</span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()" class="qira-user-menu__danger">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <main class="qira-main">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
